/* eslint-disable jsx-a11y/alt-text */
import {
  ArrowLeftIcon,
  CameraIcon,
  PhotographIcon,
  RefreshIcon,
} from "@heroicons/react/outline";
import { LoadingModal } from "Component/LoadingModal";
import { Notify } from "Component/Notify";
import { fetchApi } from "Config/fetchApi";
import React, { useRef } from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { ROUTES } from "Route/ConstantRoute";
import Webcam from "react-webcam";
import {
  base64ToFile,
  convertToISOString,
  fileToBase64,
  handleError,
  handleWarning,
} from "Helper";
import * as mp from "@mediapipe/face_mesh";
import clsx from "clsx";
import loadImage from "blueimp-load-image";
import axios from "axios";
import { use } from "react";

function CreateRegisterFace() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [nik, setNik] = useState("");
  const [fullName, setFullName] = useState("");
  const [placeOfBirth, setPlaceOfBirth] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [address, setAddress] = useState("");
  const [occupation, setOccupation] = useState("");
  const [genderId, setGenderId] = useState("");
  const [bloodTypeId, setBloodTypeId] = useState("");
  const [religionId, setReligionId] = useState("");
  const [maritalTypeId, setMaritalTypeId] = useState("");
  const [nationalityId, setNationalityId] = useState("");
  const [image, setImage] = useState("");
  const webcamRef = useRef(null);
  const canvasRef = useRef(null);
  const imgRef = useRef(null);
  const [isCameraOpen, setIsCameraOpen] = useState(false);
  const [isFrontCamera, setIsFrontCamera] = useState(true);
  const [imageRotate, setImageRotate] = useState("");
  const [responseCheckingImage, setResponseCheckingImage] = useState({});

  // ==================== State for select master data ==================== //
  const [dataGender, setDataGender] = useState([]);
  const [dataBloodType, setDataBloodType] = useState([]);
  const [dataReligion, setDataReligion] = useState([]);
  const [dataMaritalType, setDataMaritalType] = useState([]);
  const [dataNationality, setDataNationality] = useState([]);
  // console.log(webcamRef, "webcamRef");

  // ==================== Get data master ==================== //
  const getDataGender = async () => {
    try {
      setIsLoading(true);
      const response = await fetchApi().get(`/gender/get-list`);
      setDataGender(response.data?.data);
      getDataBloodType();
    } catch (err) {
      setDataGender([]);
      setIsLoading(false);
      handleError(err);
    }
  };

  const getDataBloodType = async () => {
    try {
      const response = await fetchApi().get(`/blood-type/get-list`);
      setDataBloodType(response.data?.data);
      getDataReligion();
    } catch (err) {
      setDataBloodType([]);
      setIsLoading(false);
      handleError(err);
    }
  };

  const getDataReligion = async () => {
    try {
      const response = await fetchApi().get(`religion-type/get-list`);
      setDataReligion(response.data?.data);
      getDataMaritalType();
    } catch (err) {
      setDataReligion([]);
      setIsLoading(false);
      handleError(err);
    }
  };

  const getDataMaritalType = async () => {
    try {
      const response = await fetchApi().get(`/marital-type/get-list`);
      setDataMaritalType(response.data?.data);
      getDataNationality();
    } catch (err) {
      setDataMaritalType([]);
      setIsLoading(false);
      handleError(err);
    }
  };

  const getDataNationality = async () => {
    try {
      const response = await fetchApi().get(`/nationality-type/get-list`);
      setDataNationality(response.data?.data);
      setIsLoading(false);
    } catch (err) {
      setDataNationality([]);
      setIsLoading(false);
      handleError(err);
    }
  };

  useEffect(() => {
    getDataGender();
  }, []);

  // ==================== File Upload ==================== //
  const [errorMessage, setErrorMessage] = useState(null);

  // ==================== Detect image ==================== //
  const [detectImage, setDetectImage] = useState(null);
  const [detections, setDetections] = useState(null);
  const [isDetectingFace, setIsDetectingFace] = useState(false);
  const faceMesh = useRef(null);

  const checkFrontalImage = async (image) => {
    // console.log(image, "image");
    setIsLoading(true);
    try {
      const formData = new FormData();
      formData.append("file", image);

      const response = await fetchApi().post(
        "/watchlist/checking-image-template",
        formData
      );
      // console.log(response?.data);
      let checkScore;
      if (response?.data?.score) {
        checkScore = response?.data?.score;
        const res = response.data?.data;
        setResponseCheckingImage(response.data);
      } else {
        setResponseCheckingImage({});
        // checkScore = false;
      }
      setIsLoading(false);

      return checkScore;
    } catch (error) {
      setIsLoading(false);
      setImage("");
      console.error("Error checking frontal image", error);
      return error;
    }
  };

  const checkRotateNImageMoreThanOne = async (image) => {
    setIsLoading(true);

    try {
      const base64Image = await fileToBase64(image);
      // console.log(base64Image, "base64Image");

      // Kirim base64 sebagai JSON dengan axios

      const response = await axios.post(
        "http://31.97.106.162:5000/detect_face", // ganti dengan URL backend kamu
        { image: base64Image.split(",")[1] },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      // (opsional) tangani response
      // console.log(response, "dataa");
      setIsLoading(true);

      return response.data;
    } catch (error) {
      // console.log(error, "err");
      setIsLoading(false);
      setImage("");
      console.error("Error checking frontal image", error);
      return error;
    }
  };

  const handleImageChange = async (e) => {
    const files = Array.from(e.target.files);
    if (!files || !files[0]) return;

    // Panggil kedua API
    // const isRotate = await checkRotateNImageMoreThanOne(files[0]);
    const isFrontal = await checkFrontalImage(files[0]);
    // console.log(isRotate, "isRotate");

    // Validasi rotasi
    // if (isRotate?.status) {
    //   handleWarning(isRotate?.message || "Gambar Harus Lurus");
    //   setImage("");
    //   return;
    // }

    // if (isRotate?.code) {
    //   handleWarning("API Validasi Bermasalah");
    //   setImage("");
    //   return;
    // }

    // Validasi frontal score (kalau hasil angka langsung)
    if (typeof isFrontal === "number" && isFrontal < 0.65) {
      handleWarning("Gambar pertama harus frontal!");
      setImage("");
      return;
    }

    // Validasi frontal message dari response (kalau hasil objek)
    if (isFrontal?.response?.data?.message) {
      handleWarning(isFrontal?.response?.data?.message);
      setImage("");
      return;
    }

    // Kalau semua valid → sukses
    handleSuccess("Wajah terdeteksi. Lanjutkan pengisian data diri!");
  };

  // ==================== Upload Photo ==================== //
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    // Periksa apakah file ada
    if (file) {
      const fileType = file.type;
      const fileSize = file.size;
      const maxFileSize = 2 * 1024 * 1024;
      const validImageTypes = ["image/jpeg", "image/png"];

      if (!validImageTypes.includes(fileType)) {
        Notify.error({
          title: "Gagal",
          description:
            "Jenis file tidak didukung. Harap unggah gambar (jpeg, png).",
        });
        return;
      }
      if (fileSize > maxFileSize) {
        Notify.error({
          title: "Gagal",
          description: "Ukuran file melebihi batas 2 MB.",
        });
      } else {
        // Lanjutkan dengan pengaturan state atau tindakan lainnya
        handleImageChange(e);
        setImage(file);
      }
    }
  };

  const openCamera = () => {
    setIsCameraOpen(true);
    setDetectImage(null);
  };

  const captureImage = async () => {
    const imageSrc = webcamRef.current.getScreenshot();
    if (!imageSrc) return; // Ensure there is an image to process

    // Convert base64 image to Blob
    const byteCharacters = atob(imageSrc.split(",")[1]);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "image/jpeg" });

    const base64ToFiles = base64ToFile(imageSrc, "img");
    if (base64ToFiles) {
      // const isRotate = await checkRotateNImageMoreThanOne(base64ToFiles);
      const isFrontal = await checkFrontalImage(base64ToFiles);
      // console.log(isRotate, "isRotate");

      // Validasi rotasi
      // if (isRotate?.status) {
      //   handleWarning(isRotate?.message || "Gambar Harus Lurus");
      //   setIsCameraOpen(false);
      //   webcamRef.current = null;
      //   return;
      // }

      // if (isRotate?.code) {
      //   handleWarning("API Validasi Bermasalah");
      //   setIsCameraOpen(false);
      //   webcamRef.current = null;
      //   return;
      // }

      // Validasi frontal score (kalau hasil angka langsung)
      if (typeof isFrontal === "number" && isFrontal < 0.65) {
        handleWarning("Gambar pertama harus frontal!");
        setIsCameraOpen(false);
        webcamRef.current = null;
        return;
      }

      // Validasi frontal message dari response (kalau hasil objek)
      if (isFrontal?.response?.data?.message) {
        handleWarning(isFrontal?.response?.data?.message);
        setIsCameraOpen(false);
        webcamRef.current = null;
        return;
      }

      // Kalau semua valid → sukses
      handleSuccess("Wajah terdeteksi. Lanjutkan pengisian data diri!");
    }
    // console.log(base64ToFiles, 'base64ToFile')

    // Set the captured image as the payload file
    // console.log(imageSrc.split(',')[1], 'blob')
    setImage(blob);

    // Create a new Image object for detection
    const img = new Image();
    img.src = imageSrc; // Set the source to the captured image
    img.onload = async () => {
      setDetectImage(img); // Set the detectImage state
      setIsDetectingFace(true); // Start loading for face detection
      if (faceMesh.current) {
        console.log("Sending captured image to FaceMesh for detection...");
        await faceMesh.current.send({ image: img });
      } else {
        console.error("FaceMesh belum diinisialisasi.");
        setIsDetectingFace(false); // Stop loading if FaceMesh is not initialized
      }
    };

    setIsCameraOpen(false); // Close the camera after capturing
  };

  // ==================== Default ==================== //
  const goBack = () => {
    navigate(ROUTES.management_data.RegisterFace.register_face_home);
  };
  const handleSuccess = (message) => {
    Notify.success({
      title: "Berhasil",
      description: message,
    });
  };

  // ==================== Default ==================== //

  const createData = async () => {
    try {
      setIsLoading(true);
      const convertToBase64 = (file) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
        });

      const base64Image = await convertToBase64(image);
      const strippedBase64 = base64Image.replace(
        /^data:image\/\w+;base64,/,
        ""
      );
      // console.log(dateOfBirth, "dateOfBirth");
      const reqBody = {
        nik,
        fullName,
        placeOfBirth,
        dateOfBirth: moment(dateOfBirth).format("DD-MM-YYYY"),
        address,
        occupation,
        genderId,
        bloodTypeId,
        religionId,
        maritalTypeId,
        nationalityId,
        image: strippedBase64,
      };
      const response = await fetchApi().post(`/person/register`, reqBody);
      setIsLoading(false);
      handleSuccess(response.data?.message);
      goBack();
    } catch (err) {
      setIsLoading(false);
      handleError(err);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!image) {
      Notify.error({
        title: "Gagal",
        description: "Foto tidak boleh kosong",
      });
      setErrorMessage("Foto tidak boleh kosong");
    } else {
      setErrorMessage("");
      createData();
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      if (nik.length === 16) {
        setIsLoading(true);
        try {
          // Ganti URL di bawah dengan URL API kamu
          const response = await fetchApi().post(`/person/check-nik`, { nik });
          const data = await response?.data?.message;
          handleSuccess("NIK Belum Terdaftar. Lanjutkan pengisian data diri!");
        } catch (error) {
          console.log(error, "error");
          handleWarning(error?.response?.data?.message);
          console.error("Error fetching data:", error);
        } finally {
          setIsLoading(false);
        }
      }
    };

    fetchData();
  }, [nik]);
  // console.log(nik, 'nik')

  return (
    <div>
      <div className="text-lg font-bold text-start gap-2 pb-5">
        <p
          className="text-2xl font-bold"
          style={{
            fontFamily: "Poppins",
          }}
        >
          Tambah Data Wajah
        </p>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="rounded-2xl border-solid border-gray-300 border shadow-xl bg-white p-6">
          <div className="flex justify-between items-center px-5 w-full">
            <div className="w-2/4">
              <button
                onClick={goBack}
                disabled={isLoading}
                className="bg-zinc-200 h-11 flex w-auto justify-center items-center rounded-xl hover:bg-gray-100 px-3 py-1.5 text-md font-semibold leading-6 text-black focus-visible:outline shadow-md focus-visible:outline-2 focus-visible:outline-offset-2"
              >
                <ArrowLeftIcon className="h-6 w-auto pr-2" />
                Kembali
              </button>
            </div>
          </div>

          {/* Field Kolom */}
          <div className="flex justify-center items-center py-5 px-5 w-full">
            <div className="w-full flex items-center justify-center">
              <div className="w-full flex flex-col items-center justify-center">
                <label
                  htmlFor="file"
                  className="flex text-sm font-medium leading-6"
                >
                  Foto Tampak Depan
                  <p className="ml-1 text-red-700">*</p>
                </label>
                {/* {detectImage && (
                  <div className="text-xs flex flex-col items-center justify-center mt-2">
                    {isDetectingFace ? (
                      <p>Mendeteksi wajah...</p>
                    ) : detections && detections.length > 0 ? (
                      <p>Wajah terdeteksi!</p>
                    ) : (
                      <p className="text-red-500 font-bold">
                        Tidak ada wajah terdeteksi!
                      </p>
                    )}
                  </div>
                )} */}
                <div
                  className={clsx(
                    "mt-2 aspect-square border-2 border-dashed rounded-md relative overflow-hidden flex items-center justify-center",
                    "w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/5",
                    {
                      "border-gray-300": !errorMessage,
                      "border-red-500": errorMessage,
                    }
                  )}
                >
                  <canvas ref={canvasRef} style={{ display: "none" }}></canvas>

                  {image ? (
                    <img
                      ref={imgRef}
                      src={URL.createObjectURL(image)}
                      alt="preview"
                      className="absolute inset-0 w-full h-full object-cover rounded-sm"
                    />
                  ) : (
                    <>
                      {!isCameraOpen ? (
                        <div className="flex flex-col items-center justify-center gap-2 w-full h-full p-2">
                          {/* Kamera Button */}
                          <button
                            type="button"
                            onClick={openCamera}
                            className="flex flex-col items-center justify-center bg-gray-50 hover:bg-gray-100 border border-gray-300 rounded-lg aspect-square w-1/2 max-w-[80px]"
                          >
                            <CameraIcon className="w-2/5 h-2/5 text-gray-500" />
                            <p className="text-[10px] mt-1 text-black text-center">
                              Kamera
                            </p>
                          </button>

                          {/* Galeri Button */}
                          <label
                            htmlFor="file-upload"
                            className="flex flex-col items-center justify-center bg-gray-50 hover:bg-gray-100 border border-gray-300 rounded-lg aspect-square w-1/2 max-w-[80px] cursor-pointer"
                          >
                            <PhotographIcon className="w-2/5 h-2/5 text-gray-500" />
                            <p className="text-[10px] mt-1 text-black text-center">
                              Galeri
                            </p>
                            <input
                              id="file-upload"
                              name="file-upload"
                              type="file"
                              className="sr-only"
                              onChange={handleFileChange}
                            />
                          </label>
                        </div>
                      ) : (
                        <Webcam
                          audio={false}
                          ref={webcamRef}
                          className="absolute inset-0 w-full h-full object-cover rounded-md"
                          screenshotFormat="image/jpeg"
                          videoConstraints={{
                            facingMode: isFrontCamera ? "user" : "environment",
                          }}
                        />
                      )}
                    </>
                  )}
                </div>

                <div className="w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/5 mt-2 h-[15px]">
                  {isCameraOpen ? (
                    <div className="relative w-full">
                      {/* Tombol Close (X) */}
                      <button
                        type="button"
                        onClick={() => {
                          setIsCameraOpen(false);
                          setImage(null);
                          setDetectImage(null);
                          setDetections([]);
                        }}
                        className="absolute -top-2 -right-2 text-white bg-red-500 hover:bg-red-600 rounded-full  w-5 h-5 flex items-center justify-center text-xs z-10 "
                      >
                        ✕
                      </button>

                      {/* Tombol Capture */}
                      <button
                        type="button"
                        className="w-full p-3 h-auto text-white rounded-lg font-medium disabled:bg-btn-disable disabled:cursor-not-allowed bg-primary hover:bg-opacity-90 inline-flex justify-center items-center sm:text-sm"
                        onClick={captureImage}
                        disabled={!isCameraOpen}
                      >
                        <CameraIcon className="w-[1.5em] aspect-square mr-2" />
                        <span>Capture</span>
                      </button>
                    </div>
                  ) : image ? (
                    <button
                      type="button"
                      className="w-full p-3 h-auto text-white rounded-lg font-medium disabled:bg-btn-disable disabled:cursor-not-allowed bg-primary hover:bg-opacity-90 inline-flex justify-center items-center sm:text-sm"
                      onClick={() => {
                        setImage(null);
                        setDetectImage(null);
                        setDetections([]);
                      }}
                      disabled={!image || isLoading}
                    >
                      <RefreshIcon className="w-[1.5em] aspect-square mr-2" />
                      <span>{isLoading ? "Loading..." : "Reselect Image"}</span>
                    </button>
                  ) : null}
                </div>
                <span className="text-xs mt-2 text-red-500">
                  {errorMessage}
                </span>
              </div>
            </div>
          </div>

          <div className="flex flex-col py-5 px-5 w-full gap-4">
            {/* Row 1 - NIK and Full Name */}
            <div className="flex flex-col md:flex-row justify-between items-center w-full gap-4">
              <div className="mb-2 w-full md:w-[48%]">
                <label
                  htmlFor="register_face_nik"
                  className="flex block text-sm font-medium leading-6"
                >
                  NIK
                  <p className="ml-1 text-red-700">*</p>
                </label>
                <div className="mt-2">
                  <input
                    id="register_face_nik"
                    name="register_face_nik"
                    type="text"
                    maxLength={16}
                    disabled={isLoading}
                    value={nik}
                    placeholder="Masukkan NIK"
                    onChange={(e) => setNik(e.target.value)}
                    required
                    className="capitalize h-11 block px-2 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                  />
                </div>
              </div>

              <div className="mb-2 w-full md:w-[48%]">
                <label
                  htmlFor="register_face_full_name"
                  className="flex block text-sm font-medium leading-6"
                >
                  Nama Lengkap
                  <p className="ml-1 text-red-700">*</p>
                </label>
                <div className="mt-2">
                  <input
                    id="register_face_full_name"
                    name="register_face_full_name"
                    type="text"
                    disabled={isLoading}
                    placeholder="Masukkan Nama Lengkap"
                    value={fullName}
                    onChange={(e) => setFullName(e.target.value)}
                    required
                    className="capitalize h-11 block px-2 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                  />
                </div>
              </div>
            </div>

            {/* Row 2 - Place of Birth and Date of Birth */}
            <div className="flex flex-col md:flex-row justify-between items-center w-full gap-4">
              <div className="mb-2 w-full md:w-[48%]">
                <label
                  htmlFor="register_face_place_of_birth"
                  className="flex block text-sm font-medium leading-6"
                >
                  Tempat Lahir
                  <p className="ml-1 text-red-700">*</p>
                </label>
                <div className="mt-2">
                  <input
                    id="register_face_place_of_birth"
                    name="register_face_place_of_birth"
                    type="text"
                    placeholder="Masukan Tempat Lahir"
                    disabled={isLoading}
                    value={placeOfBirth}
                    onChange={(e) => setPlaceOfBirth(e.target.value)}
                    required
                    className="h-11 block px-2 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                  />
                </div>
              </div>
              <div className="mb-2 w-full md:w-[48%]">
                <label
                  htmlFor="register_face_date_of_birth"
                  className="flex block text-sm font-medium leading-6"
                >
                  Tanggal Lahir
                  <p className="ml-1 text-red-700">*</p>
                </label>
                <div className="mt-2">
                  <input
                    id="register_face_date_of_birth"
                    name="register_face_date_of_birth"
                    type="date"
                    disabled={isLoading}
                    value={dateOfBirth}
                    placeholder="DD-MM-YYYY"
                    onChange={(e) => setDateOfBirth(e.target.value)}
                    required
                    className="h-11 block px-2 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                  />
                </div>
              </div>
            </div>

            {/* Row 3 - Nationality and Occupation */}
            <div className="flex flex-col md:flex-row justify-between items-center w-full gap-4">
              <div className="mb-2 w-full md:w-[48%]">
                <label
                  htmlFor="register_face_nationality_id"
                  className="flex block text-sm font-medium leading-6"
                >
                  Kewarganegaraan
                  <p className="ml-1 text-red-700">*</p>
                </label>
                <div className="mt-2">
                  <div className="relative w-full">
                    <select
                      id="register_face_nationality_id"
                      name="register_face_nationality_id"
                      required
                      disabled={isLoading}
                      value={nationalityId}
                      onChange={(e) => {
                        setNationalityId(e.target.value);
                      }}
                      className={`${isLoading ? "bg-zinc-100" : ""} h-11 block px-4 pr-10 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6 appearance-none`}
                    >
                      <option value="" disabled selected hidden>
                        Pilih Status
                      </option>
                      {Array.isArray(dataNationality) &&
                        dataNationality?.map((item) => (
                          <option value={item?.id} key={item?.id}>
                            {item?.nationality_type_name}
                          </option>
                        ))}
                    </select>

                    <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                      <svg
                        className="w-5 h-5 text-gray-400"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="2"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M19 9l-7 7-7-7"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mb-2 w-full md:w-[48%]">
                <label
                  htmlFor="register_face_occupation"
                  className="flex block text-sm font-medium leading-6"
                >
                  Pekerjaan
                  <p className="ml-1 text-red-700">*</p>
                </label>
                <div className="mt-2">
                  <input
                    id="register_face_occupation"
                    name="register_face_occupation"
                    type="text"
                    placeholder="Masukan Pekerjaan"
                    disabled={isLoading}
                    value={occupation}
                    onChange={(e) => setOccupation(e.target.value)}
                    required
                    className="h-11 block px-2 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                  />
                </div>
              </div>
            </div>

            {/* Row 4 - Gender and Marital Status */}
            <div className="flex flex-col md:flex-row justify-between items-center w-full gap-4">
              <div className="mb-2 w-full md:w-[48%]">
                <label
                  htmlFor="register_face_gender_id"
                  className="flex block text-sm font-medium leading-6"
                >
                  Jenis Kelamin
                  <p className="ml-1 text-red-700">*</p>
                </label>
                <div className="mt-2">
                  <div className="relative w-full">
                    <select
                      id="register_face_gender_id"
                      name="register_face_gender_id"
                      required
                      disabled={isLoading}
                      value={genderId}
                      onChange={(e) => {
                        setGenderId(e.target.value);
                      }}
                      className={`${isLoading ? "bg-zinc-100" : ""} h-11 block px-4 pr-10 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6 appearance-none`}
                    >
                      <option value="" disabled selected hidden>
                        Pilih Jenis Kelamin
                      </option>
                      {Array.isArray(dataGender) &&
                        dataGender?.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.gender_name}
                          </option>
                        ))}
                    </select>

                    <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                      <svg
                        className="w-5 h-5 text-gray-400"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="2"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M19 9l-7 7-7-7"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mb-2 w-full md:w-[48%]">
                <label
                  htmlFor="register_face_marital_type"
                  className="flex block text-sm font-medium leading-6"
                >
                  Status Perkawinan
                  <p className="ml-1 text-red-700">*</p>
                </label>
                <div className="mt-2">
                  <div className="relative w-full">
                    <select
                      id="register_face_marital_type"
                      name="register_face_marital_type"
                      required
                      value={maritalTypeId}
                      disabled={isLoading}
                      onChange={(e) => setMaritalTypeId(e.target.value)}
                      className={`${
                        isLoading ? "bg-zinc-100" : ""
                      } h-11 block px-4 pr-10 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6 appearance-none`}
                    >
                      <option value="" disabled selected hidden>
                        Pilih Status Perkawinan
                      </option>
                      {Array.isArray(dataMaritalType) &&
                        dataMaritalType?.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.marital_type_name}
                          </option>
                        ))}
                    </select>
                    <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                      <svg
                        className="w-5 h-5 text-gray-400"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="2"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M19 9l-7 7-7-7"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Row 5 - Blood Type and Religion */}
            <div className="flex flex-col md:flex-row justify-between items-center w-full gap-4">
              <div className="mb-2 w-full md:w-[48%]">
                <label
                  htmlFor="register_face_blood_type_id"
                  className="flex block text-sm font-medium leading-6"
                >
                  Gol Darah
                  <p className="ml-1 text-red-700">*</p>
                </label>
                <div className="mt-2">
                  <div className="relative w-full">
                    <select
                      id="register_face_blood_type_id"
                      name="register_face_blood_type_id"
                      required
                      disabled={isLoading}
                      value={bloodTypeId}
                      onChange={(e) => {
                        setBloodTypeId(e.target.value);
                      }}
                      className={`${isLoading ? "bg-zinc-100" : ""} h-11 block px-4 pr-10 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6 appearance-none`}
                    >
                      <option value="" disabled selected hidden>
                        Pilih Gol Darah
                      </option>
                      {Array.isArray(dataBloodType) &&
                        dataBloodType?.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.blood_type_name}
                          </option>
                        ))}
                    </select>

                    <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                      <svg
                        className="w-5 h-5 text-gray-400"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="2"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M19 9l-7 7-7-7"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mb-2 w-full md:w-[48%]">
                <label
                  htmlFor="register_face_religion_id"
                  className="flex block text-sm font-medium leading-6"
                >
                  Agama
                  <p className="ml-1 text-red-700">*</p>
                </label>
                <div className="mt-2">
                  <div className="relative w-full">
                    <select
                      id="register_face_religion_id"
                      name="register_face_religion_id"
                      required
                      value={religionId}
                      disabled={isLoading}
                      onChange={(e) => setReligionId(e.target.value)}
                      className={`${
                        isLoading ? "bg-zinc-100" : ""
                      } h-11 block px-4 pr-10 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6 appearance-none`}
                    >
                      <option value="" disabled selected hidden>
                        Pilih Agama
                      </option>
                      {Array.isArray(dataReligion) &&
                        dataReligion?.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.religion_type_name}
                          </option>
                        ))}
                    </select>
                    <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                      <svg
                        className="w-5 h-5 text-gray-400"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="2"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M19 9l-7 7-7-7"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Row 6 - Address (full width) */}
            <div className="flex justify-between items-center w-full">
              <div className="mb-2 w-full">
                <label
                  htmlFor="register_face_address"
                  className="flex block text-sm font-medium leading-6"
                >
                  Alamat Tempat Tinggal
                  <p className="ml-1 text-red-700">*</p>
                </label>
                <div className="mt-2">
                  <textarea
                    id="register_face_address"
                    name="register_face_address"
                    disabled={isLoading}
                    value={address}
                    placeholder="Masukkan Alamat Tempat Tinggal"
                    onChange={(e) => setAddress(e.target.value)}
                    required
                    className="h-28 block px-2 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="flex items-center justify-end mr-5">
            <button
              type="submit"
              className="h-11 flex w-auto justify-center items-center rounded-xl bg-btn-login hover:bg-opacity-50 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
            >
              Simpan
            </button>
          </div>
        </div>
      </form>
      <LoadingModal open={isLoading} />
    </div>
  );
}

export default CreateRegisterFace;
